'use client';

import { useLocale, useTranslations } from 'next-intl';
import type { Amount } from '@/src/types/costAndFees.type';
import Card from '@/src/components/features/property/ui/Card';
import { addAmounts } from './feeCalculation';
import { formatAmount } from './costFeeUtils';
import {
  summaryLabel,
  summaryList,
  summaryRow,
  summaryValue,
  totalAmount,
  totalLabel,
} from './costAndFeesModule.styles';

type Props = {
  costs: {
    monthly?: { amount?: Amount; displayName?: string };
    moveIn?: { amount?: Amount; displayName?: string };
  };
};

export const CostSummaryCard = ({ costs }: Props) => {
  const t = useTranslations('hdp');
  const locale = useLocale();
  const numberLocale = locale === 'es' ? 'es' : 'en-US';
  const monthly = costs.monthly?.amount;
  const moveIn = costs.moveIn?.amount;

  if (!monthly && !moveIn) return null;

  const total = addAmounts(monthly, moveIn);

  return (
    <Card variant="default" size="md">
      <div aria-live="polite" aria-atomic="true">
        <div className={totalAmount}>{formatAmount(total, numberLocale)}</div>
        <div className={totalLabel}>{t('estTotalMoveIn')}</div>
        <dl className={summaryList}>
          <div className={summaryRow}>
            <dt className={summaryLabel}>{t('monthlyRentFees')}</dt>
            <dd className={summaryValue}>{formatAmount(monthly, numberLocale)}</dd>
          </div>
          <div className={summaryRow}>
            <dt className={summaryLabel}>{t('oneTimeFees')}</dt>
            <dd className={summaryValue}>{formatAmount(moveIn, numberLocale)}</dd>
          </div>
        </dl>
      </div>
    </Card>
  );
};
